import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    getChips,
    updateChip,
    deleteChip,
    createChip,
    updateChipList
} from '../../../services/chips';


export const fetchchipsAsync = createAsyncThunk(
    'chips/fetchList',
    async (params = {}, { rejectWithValue }) => {
        try {
            const response = await getChips(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch chips');
        }
    }
);
export const createChipAsync = createAsyncThunk(
    'chips/create',
    async (chipData, { rejectWithValue }) => {
        try {
            const response = await createChip(chipData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create chip');
        }
    }
);

export const updateChipAsync = createAsyncThunk(
    'chips/update',
    async ({ chipId, chipData }, { rejectWithValue }) => {
        try {
            const response = await updateChip(chipId, chipData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to update chip');
        }
    }
);

export const updateChipListAsync = createAsyncThunk(
    'chips/updateList',
    async (chipData, { rejectWithValue }) => {
        try {
            const response = await updateChipList(chipData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to update chip list');
        }
    }
);

export const deleteChipAsync = createAsyncThunk(
    'chips/delete',
    async (chipId, { rejectWithValue }) => {
        try {
            const response = await deleteChip(chipId);
            return { chipId, ...response.data };
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to delete chip');
        }
    }
);



const chipsSlice = createSlice({
    name: 'chips',
    initialState: {
        chips: [
            {
                'chip_label': '100',
                'chip_value': 100
            },
            {
                'chip_label': '200',
                'chip_value': 200
            },
            {
                'chip_label': '500',
                'chip_value': 500
            },
            {
                'chip_label': '1000',
                'chip_value': 1000
            },
            {
                'chip_label': '5000',
                'chip_value': 5000
            },
            {
                'chip_label': '10000',
                'chip_value': 10000
            },
            {
                'chip_label': '50000',
                'chip_value': 50000
            }
        ],
        loading: false,
        isDefaultChip: true,
        error: null,
        lastOperation: null
    },
    reducers: {
        clearLastOperation: (state) => {
            state.lastOperation = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchchipsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.isDefaultChip = true;
            })
            .addCase(fetchchipsAsync.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload?.length > 0) {
                    state.chips = action.payload;
                    state.isDefaultChip = false;
                }
                state.error = null;
            })
            .addCase(fetchchipsAsync.rejected, (state, action) => {
                state.loading = false;
                state.chips = [];
                state.isDefaultChip = true;
                state.error = action.payload;
            })

            .addCase(createChipAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createChipAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.isDefaultChip = false;
                state.chips.push(action.payload);
                state.lastOperation = 'create';
            })
            .addCase(createChipAsync.rejected, (state, action) => {
                state.loading = false;
                state.isDefaultChip = true;
                state.error = action.payload;
            })

            .addCase(updateChipAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.isDefaultChip = false;
            })
            .addCase(updateChipAsync.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.chips.findIndex(chip => chip._id === action.payload._id);
                if (index !== -1) {
                    state.chips[index] = action.payload;
                }
                state.lastOperation = 'update';
            })
            .addCase(updateChipAsync.rejected, (state, action) => {
                state.loading = false;
                state.isDefaultChip = true;
                state.error = action.payload;
            })

            .addCase(deleteChipAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.isDefaultChip = true;
            })
            .addCase(deleteChipAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.chips = state.chips.filter(chip => chip._id !== action.payload.chipId);
                state.lastOperation = 'delete';
            })
            .addCase(deleteChipAsync.rejected, (state, action) => {
                state.loading = false;
                state.isDefaultChip = true;
                state.error = action.payload;
            });

    }
});

export const { clearLastOperation } = chipsSlice.actions;
export default chipsSlice.reducer;